import React, { useEffect, useRef, useState } from "react";
import "./Overview.css";
import Button from "../../reusableComponents/Button/Button";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import QrCodePopup from "../../overlay/QrCodePopup/QrCodePopup";
import { checkIfIsRoyalInternational } from "../../../utilities/helper";
import BgVideoNew from "../../../assets/videos/delorean_desktop_welc_vid.mp4";
import BgVideoMobileNew from "../../../assets/videos/delorean_mobile_welc_vid.mp4";
import { useDispatch, useSelector } from "react-redux";
import {
    getCustomerHolidayItineraries,
    selectCustomerHolidayItineraries,
} from "../../../features/customerHolidayItineraries/customerHolidayItinerariesSlice";
import Spinner from "../../reusableComponents/Spinner/Spinner";
import { addToLoader } from "../../../features/loader/loaderSlice";
import { useMediaQuery } from "react-responsive";

import { getCurrentTranslations } from "../../../utilities/helper";
import translationResources from "../../../utilities/multiLanguage";

function Overview({isLegend = false}) {
    // Handle Translations
    const [translations, setTranslations] = useState({});
    useEffect(() => {
        setTranslations(translationResources["overview"][window.currentLanguage]);
    }, []);
    //End ./ Handle Translations
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const customerHolidaysItinerariesData = useSelector(selectCustomerHolidayItineraries);
    const [customerName, setCustomerName] = useState("...");
    const isMobile = useMediaQuery({ query: "(max-width: 853px)" });
    const [showQrCodePopup, setShowQrCodePopup] = useState(false);

    useEffect(() => {
        console.log('***** isLegend: ', isLegend)
    }, []);

    const handleGoToYourCruise = () => {
        if (params?.unique_code) {
            navigate(`/your-cruise/${params.type_share}/${params.unique_code}`);
        } else {
            navigate("/your-cruise");
        }
    };

    const handleGoToYourCruiseLegend = () => {
        navigate("/your-cruise/legend");
    };

    useEffect(() => {
        if (isLegend) return;

        dispatch(addToLoader(true));
        dispatch(getCustomerHolidayItineraries({ unique_code: params.unique_code }));
        dispatch(addToLoader(false));
    }, []);

    useEffect(() => {
        if (isLegend) return;

        if (customerHolidaysItinerariesData?.data === "ERROR_INVALID_LINK_CODE") {
            navigate("/errorpage");
            return;
        }

        setCustomerName(customerHolidaysItinerariesData?.data?.customer_name);

        if (
            searchParams.get("royal_international_event_popup") === "true" &&
            checkIfIsRoyalInternational(
                customerHolidaysItinerariesData?.data?.agent_company_uid
            )
        ) {
            setShowQrCodePopup(true);
        }

        console.log('*** customerHolidaysItinerariesData: ', customerHolidaysItinerariesData)
    }, [customerHolidaysItinerariesData]);

    return (
        <div className="w-full overview">
            {/* Not deleted this popup just in case we need again */}
            {/* {showQrCodePopup && (
                <QrCodePopup
                    onClose={() => setShowQrCodePopup(false)}
                    userUid={customerHolidaysItinerariesData?.data?.agent_uid}
                />
            )} */}
            <section className="overview__hero lg:min-h-screen relative mb-[2.9rem] lg:mb-0">
                {!isMobile ? (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: `<video autoplay loop muted playsinline id="overview__hero_video">
                                <source src=${BgVideoNew} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>`,
                        }}
                    />
                ) : (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: `<video autoplay loop muted playsinline id="overview__hero_video">
                            <source src=${BgVideoMobileNew} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>`,
                        }}
                    />
                )}

                {/* <video autoPlay={true} muted loop id="overview__hero_video">
                    <source src={BgVideo} type="video/mp4" />
                </video> */}

                <div className="h-screen max-w-screen-xl px-4 py-4 mx-auto lg:pt-0 lg:pb-8 lg:py-16 xl:py-16 flex flex-col items-center justify-center">
                    {/* <div className="m-auto place-self-center">
                        <h1 className="mb-6 lg:mb-4 text-center text-[3rem] lg:text-[3.75rem] leading-[1.75rem] lg:leading-[4.125rem] uppercase tracking-[0.2rem] lg:tracking-[0.5rem] text-white  font-kapraRegular">
                            {customerName}
                        </h1>
                        <div className="flex items-center justify-center mt-2 overview__hero_btn">
                            <h3 className=" overview__hero_btnText text-center text-[1.25rem] lg:text-[2.5rem] tracking-[4.5px] leading-[2.688rem] uppercase font-kapraBold text-white">
                                {getCurrentTranslations("overview", "textNextHoliday")}
                            </h3>
                        </div>
                        <div className="hidden lg:flex lg:justify-center lg:items-center lg:mt-6 lg:mb-8">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="316"
                                height="5"
                                fill="none"
                                viewBox="0 0 316 5"
                            >
                                <path fill="#F9C20A" d="M0 0h316v5H0z" />
                            </svg>
                        </div>
                        <div className="mx-auto mt-4 lg:mt-8 lg:pt-4">
                            <Button
                                type={8}
                                text={getCurrentTranslations("overview", "buttonExplore")}
                                className="mx-auto overview__hero_cta lg:px-6"
                                onClick={() => handleGoToYourCruise()}
                            />
                        </div>
                    </div> */}
                    <div
                        className="flex flex-col gap-6 rounded-lg p-4 w-full max-w-[560px] lg:mx-0 mx-4"
                        style={{
                            background: "linear-gradient(180deg, #83F 0%, #0080FF 100%)",
                        }}
                    >
                        <h1 className="font-kapraRegular text-[96px] tracking-[0.96px] text-white leading-none uppercase text-center">
                            {isLegend ? 'LEGENDS' : (
                                <>
                                    {checkIfIsRoyalInternational(customerHolidaysItinerariesData?.data?.agent_company_uid) ? customerHolidaysItinerariesData?.data?.first_name : customerName}
                                </>
                            )}
                        </h1>
                        <h3 className="font-kapraRegular text-[48px] tracking-[0.48px] text-white leading-none uppercase text-center">
                            {getCurrentTranslations("overview", "textNextHoliday")}
                        </h3>
                    </div>

                    <div className="mx-auto mt-4 lg:mt-8 lg:px-0 px-4 ">
                        <Button
                            type={10}
                            text={getCurrentTranslations("overview", "buttonExplore")}
                            className="mx-auto overview__hero_cta lg:px-6 !w-full !max-w-[272px]"
                            onClick={() => isLegend ? handleGoToYourCruiseLegend() : handleGoToYourCruise()}
                        />
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Overview;
